import { render, staticRenderFns } from "./redesign-step-3.vue?vue&type=template&id=426bbc81&scoped=true&"
import script from "./redesign-step-3.vue?vue&type=script&lang=ts&"
export * from "./redesign-step-3.vue?vue&type=script&lang=ts&"
import style0 from "./redesign-step-3.vue?vue&type=style&index=0&id=426bbc81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426bbc81",
  null
  
)

export default component.exports